<template>
  <span>
    <div
      class="methods"
      v-if="browserSize.sm === true || browserSize.xs === true"
    >
      <MethodGrid />
    </div>
    <div class="methods2" v-else>
      <MethodGrid />
    </div>
  </span>
</template>

<script>
// import MethodTab from "../components/MethodTab.vue";
import MethodGrid from "../components/MethodGrid.vue";

export default {
  components: {
    MethodGrid,
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.methods {
  margin-top: 12vh;
}
.methods2 {
  margin-top: 4vh;
}
</style>
